export enum AxeGridColumnId {
  STATUS = 'STATUS',
  MARKET_TYPE = 'MARKET_TYPE',
  AXE_ID = 'AXE_ID',
  EXTERNAL_AXE_ID = 'EXTERNAL_AXE_ID',
  MY_ENTITY = 'MY_ENTITY',
  COUNTERPARTY = 'COUNTERPARTY',
  INSTRUMENT = 'INSTRUMENT',
  ISIN_BUI = 'ISIN_BUI',
  CUSIP = 'CUSIP',
  CURRENCY = 'CURRENCY',
  AXE_NOTIONAL = 'AXE_NOTIONAL',
  AXE_START_CONSIDERATION = 'AXE_START_CONSIDERATION',
  DIRECTION = 'DIRECTION',
  START_DATE = 'START_DATE',
  END_DATE = 'END_DATE',
  TERM = 'TERM',
  REPO_TYPE = 'REPO_TYPE',
  MY_FIRM = 'MY_FIRM',
  PRODUCT = 'PRODUCT',
  SECTOR = 'SECTOR',
  COUPON = 'COUPON',
  ISSUER = 'ISSUER',
  LAST_UPDATED_TIME = 'LAST_UPDATED_TIME',
  CREATION_TIME = 'CREATION_TIME',
  CREATED_BY = 'CREATED_BY',
  UPDATED_BY = 'UPDATED_BY',
  RATE = 'RATE',
  FEE = 'FEE',
  REFERENCE_RATE = 'REFERENCE_RATE',
  MY_ENTITY_SHORT_NAME = 'MY_ENTITY_SHORT_NAME',
  ASSET_TYPE = 'ASSET_TYPE',
  FACTOR = 'FACTOR',
  ISSUE = 'ISSUE',
  MARKET_TRADE_DATE = 'MARKET_TRADE_DATE',
  MY_FICC_ENTITY_SHORT_NAME = 'MY_FICC_ENTITY_SHORT_NAME'
}

export const AxeFieldNamePrefix = 'axe'
export const AxeFieldNames = {
  NOTIONAL: `${AxeFieldNamePrefix}.notional`,
  DIRECTION: `${AxeFieldNamePrefix}.direction`,
  RESPONDER_ORGANISATION_IDS: `${AxeFieldNamePrefix}.responderOrganisationIds`,
  CURRENCY: `${AxeFieldNamePrefix}.currency`,
  RATE: `${AxeFieldNamePrefix}.rate`,
  FEE: `${AxeFieldNamePrefix}.fee`,
  REFERENCE_RATE: `${AxeFieldNamePrefix}.referenceRate`,
  START_CONSIDERATION: `${AxeFieldNamePrefix}.startConsideration`,
  START_DATE: `${AxeFieldNamePrefix}.startDate`,
  END_DATE: `${AxeFieldNamePrefix}.endDate`,
  REPO_TYPE: `${AxeFieldNamePrefix}.repoType`,
  TERM: `${AxeFieldNamePrefix}.term`,
  COLLATERAL_BASKET: `${AxeFieldNamePrefix}.collateralBasketId`,
  COLLATERAL: `${AxeFieldNamePrefix}.collateralId`,
  INSTRUMENT: `instrument.id`
} as const

export type AxeFieldName = typeof AxeFieldNames[keyof typeof AxeFieldNames]
